import React, { Component } from 'react';
import { Link } from "react-router-dom";

import styled from 'styled-components';

const MenuWrapper = styled.div`
  position: relative;
  font-size: 16px;
  padding: -1rem 1rem 1rem 1rem;
  // outline: 1px solid red;

  > select {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100% !important;
    opacity: 0;
    font-size: 16px;
  }
`

const MenuButton = styled.div`
  cursor: pointer;
`

const MenuIcon = styled.div`
  width:   24px;
  height: 24px;
  pointer-events: none;

  > svg {
    width: 100%;
    height: 100%;
  }
`
const MenuOptions = styled.ul`
  position: absolute;
  right: calc(50% - 1.7rem);
  top: 200%;
  background-color: #efefef;
  box-shadow: 0 4px 20px 1px rgba(0,0,0,0.1);
  border-radius: 4px;
  z-index: 1000;
  transform: translateY(-1rem);
  transition: transform .25s ease-out,
              opacity .25s ease-out,
              visibility .25s ease-out;
  opacity: 0;
  visibility: hidden;
  ${({ visible }) => visible && `
    visibility: visible;
    opacity: 1;
    transform: translateY(0%);
  `}

  &:before {
    content: '';
    position: absolute;
    top: -.6rem;
    right: 1rem;
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 4px;
    transform: rotate(45deg);
    background-color: #efefef;
    pointer-events: none;
  }
`


const MenuOption = styled.li`
  font-size: 16px;
  cursor: pointer;
  display: flex;
  // justify-content: stretch;
  min-width: 11rem;
  
  &:not(:last-child) {
    border-bottom: 1px solid #ccc; 
  }
  
  > * {
    flex: 1;
    padding: .85rem 1.25rem;
    white-space: nowrap;
    text-align: center;
  }
`

export default class Menu extends Component {
  constructor(props) {
    super(props)

    this.state = {};
  }

  isWithinParent(parent, target) {
    if (parent === target) {
      return true;
    }
    if (target) {
      return this.isWithinParent(parent, target.parentNode)
    } else {
      return false;
    }
  }

  handleMouseDown = (e) => {
    if (!this.isWithinParent(this.menuOptions, e.target)) {
      document.removeEventListener('mousedown', this.handleMouseDown);
      if (this.isWithinParent(this.menuButton, e.target)) { return; }
      this.setState({ visible: false });
    }
  }

  toggleMenu = () => {
    if (this.state.visible) {
      this.setState({ visible: false });
      document.removeEventListener('mousedown', this.handleMouseDown);
    } else {
      this.setState({ visible: true });
      document.addEventListener('mousedown', this.handleMouseDown);
    }
  }

  render() {
    return (
      <MenuWrapper>
        <MenuButton onClick={this.toggleMenu} innerRef={(el) => { this.menuButton = el }}>
          {this.props.icon ? <MenuIcon >{this.props.icon}</MenuIcon> : <span>{this.props.label}</span>}
        </MenuButton>
        <MenuOptions visible={this.state.visible} innerRef={(el) => { this.menuOptions = el }}>
          {this.props.options && this.props.options.map((option, i) => (
            <MenuOption key={`headerMenu-${i}`}>
              {option.to ? <Link to={option.to}>{option.label}</Link> : <div onClick={option.onClick}>{option.label}</div>}
            </MenuOption>
          ))}
        </MenuOptions>
      </MenuWrapper >
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Menu.js